import { stripHtml } from "./descriptionEditorConfig";

export const isRequiredNameFilled = (value: string): boolean =>
  value.trim().length > 0;

export const isRequiredRichTextFilled = (value: string): boolean =>
  stripHtml(value).trim().length > 0;

export const isNameAndDescriptionFilled = (
  name: string,
  description: string
): boolean =>
  isRequiredNameFilled(name) && isRequiredRichTextFilled(description);
